/* eslint-disable import/no-cycle */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { RootState } from "../store";

import {
  LocalGovernmentTypes,
  SearchHistoryTypes,
  UserTypes,
} from "../../types";

interface JudicialDivision {
  id: number;
  name: string;
}
export interface GlobalState {
  propertyDetails: SearchHistoryTypes | null;
  storedEmail: string;
  verifyType: "REGISTER" | "PASSWORD_RESET";
  caseDetailsModal: boolean;
  caseDetails: SearchHistoryTypes | null; // both comes with the same data types
  deleteModal: boolean;
  selectedUser: UserTypes | null;
  platformChargeModal: boolean;
  localGovernMentModal: boolean;
  localGovernment: LocalGovernmentTypes | null;
  editMode: boolean;
  deleteModalLga: boolean;
  deleteJudicialDivisionModal: boolean;
  judicialDivision: JudicialDivision | null;
  caseFormModal: boolean;
  judicialDivisionModal: boolean;
  reference: string | null;
}

const initialState: GlobalState = {
  propertyDetails: null,
  storedEmail: "",
  verifyType: "REGISTER",
  caseDetailsModal: false,
  caseDetails: null,
  deleteModal: false,
  selectedUser: null,
  platformChargeModal: false,
  localGovernMentModal: false,
  localGovernment: null,
  editMode: false,
  deleteModalLga: false,
  deleteJudicialDivisionModal: false,
  judicialDivision: null,
  caseFormModal: false,
  judicialDivisionModal: false,
  reference: null,
};

export const GlobalSlice = createSlice({
  initialState,
  name: "globalstate",
  reducers: {
    setStoredEmail: (state, action) => {
      state.storedEmail = action.payload;
    },
    setSelectedProperty: (state, action: PayloadAction<SearchHistoryTypes>) => {
      state.propertyDetails = action.payload;
    },
    setSelectedCaseDetails: (
      state,
      action: PayloadAction<SearchHistoryTypes | null>
    ) => {
      state.caseDetails = action.payload;
    },
    setVerifyType: (state, action) => {
      state.verifyType = action.payload;
    },
    setCaseDetailModal: (state, action) => {
      state.caseDetailsModal = action.payload;
    },
    setDeleteModal: (state, action) => {
      state.deleteModal = action.payload;
    },
    setSelectedUser: (state, action: PayloadAction<UserTypes>) => {
      state.selectedUser = action.payload;
    },
    setPlatformModal: (state, action) => {
      state.platformChargeModal = action.payload;
    },
    setLocalgovernmentModal: (state, action) => {
      state.localGovernMentModal = action.payload;
    },
    setEditMode: (state, action) => {
      state.editMode = action.payload;
    },
    setLocalgovernment: (
      state,
      action: PayloadAction<LocalGovernmentTypes | null>
    ) => {
      state.localGovernment = action.payload;
    },
    setJudicialDivision: (
      state,
      action: PayloadAction<JudicialDivision | null>
    ) => {
      state.judicialDivision = action.payload;
    },
    setLocalgovernmentDeleteModal: (state, action) => {
      state.deleteModalLga = action.payload;
    },
    setJudicialDivisionDeleteModal: (state, action) => {
      state.deleteJudicialDivisionModal = action.payload;
    },
    setCaseFormModal: (state, action) => {
      state.caseFormModal = action.payload;
    },
    setJudicialDivisionModal: (state, action) => {
      state.judicialDivisionModal = action.payload;
    },
    setReference: (state, action) => {
      state.reference = action.payload;
    },
  },
});

export const {
  setStoredEmail,
  setVerifyType,
  setSelectedProperty,
  setSelectedCaseDetails,
  setCaseDetailModal,
  setDeleteModal,
  setSelectedUser,
  setPlatformModal,
  setLocalgovernmentModal,
  setLocalgovernment,
  setEditMode,
  setJudicialDivisionModal,
  setLocalgovernmentDeleteModal,
  setJudicialDivisionDeleteModal,
  setJudicialDivision,
  setCaseFormModal,
  setReference,
} = GlobalSlice.actions;

export const selectEmail = (state: RootState) => state.globalstate.storedEmail;
export const selectProperty = (state: RootState) =>
  state.globalstate.propertyDetails;
export const selectCase = (state: RootState) => state.globalstate.caseDetails;
export const openCaseModal = (state: RootState) =>
  state.globalstate.caseDetailsModal;
export const selectVerifyType = (state: RootState) =>
  state.globalstate.verifyType;
export const showDeleteModal = (state: RootState) =>
  state.globalstate.deleteModal;
export const selectSelectedUser = (state: RootState) =>
  state.globalstate.selectedUser;
export const showPlatformChargeModal = (state: RootState) =>
  state.globalstate.platformChargeModal;
export const showLocalGovernMentModal = (state: RootState) =>
  state.globalstate.localGovernMentModal;
export const selectLocalGovernMent = (state: RootState) =>
  state.globalstate.localGovernment;
export const selectJudicialDivision = (state: RootState) =>
  state.globalstate.judicialDivision;
export const selectEditMode = (state: RootState) => state.globalstate.editMode;
export const selectLocalGovernMentDeleteModal = (state: RootState) =>
  state.globalstate.deleteModalLga;
export const selectJudicialDivisonDeleteModal = (state: RootState) =>
  state.globalstate.deleteJudicialDivisionModal;
export const selectCaseFormModal = (state: RootState) =>
  state.globalstate.caseFormModal;
export const selectJudicialModal = (state: RootState) =>
  state.globalstate.judicialDivisionModal;
export const selectReference = (state: RootState) =>
  state.globalstate.reference;

export const GlobalReducer = GlobalSlice.reducer;
